export const embedUrl = (url) => {
  if (url.includes('vimeo')) {
    url = url.replace('/vimeo.com', '/player.vimeo.com/video')

    const [newUrl, hash] = handleUnlistedVimeoUrls(url)

    let paramsToAdd = '?dnt=1'
    if (hash) {
      paramsToAdd += '&h=' + hash
    }

    if (url.includes('?')) {
      url = url.replace('?', paramsToAdd + '&')
    } else {
      url += paramsToAdd
    }

    return url
  }

  if (url.includes('youtu.be')) {
    url = url.replace('youtu.be', 'www.youtube.com/embed')

    if (url.includes('?t=')) {
      url = url.replace('?t=', '?start=')
    }
  }

  if (url.includes('youtube.com/watch?v=')) {
    url = url.replace('watch?v=', 'embed/')
  }

  if (url.includes('youtube.com')) {
    url = url.replace('youtube.com', 'youtube-nocookie.com')
  }

  return url
}

export const isEmbeddable = (url) => {
  if (!url) return false
  return (
    url.includes('youtu.be') || url.includes('youtube') || url.includes('vimeo')
  )
}
